import { RootState } from "src/redux/store";

const root = (s: RootState) => s.experiences.leadsAndReports;

export const selectReportType = (s: RootState) => root(s).reportType;
export const selectDateFilter = (s: RootState) => root(s).dateFilter;
export const selectSelectedLead = (s: RootState) => root(s).selectedLead;
export const selectSelectedLeadProfileId = (s: RootState) =>
  root(s).selectedLead?.profileId ?? null;
